import React from 'react';
import { Grid, TextField } from '@mui/material';
import { Student } from '@/types';

interface BehavioralSectionProps {
  values: Partial<Student>;
  onChange: (id: keyof Student, value: any) => void;
}

export const BehavioralSection: React.FC<BehavioralSectionProps> = ({
  values,
  onChange
}) => {
  const handleChange = (field: keyof Student) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.type === 'number' 
      ? parseInt(event.target.value) || 0
      : event.target.value;
    onChange(field, value);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="number"
          label="Behavioral Incidents (YTD)"
          value={values.behavioralIncidents || ''}
          onChange={handleChange('behavioralIncidents')}
          inputProps={{ min: 0 }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="number"
          label="Counseling Sessions (YTD)"
          value={values.counselingSessions || ''}
          onChange={handleChange('counselingSessions')}
          inputProps={{ min: 0 }}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Behavioral Notes"
          value={values.behavioralNotes || ''}
          onChange={handleChange('behavioralNotes')}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Extracurricular Activities"
          value={values.extracurricular || ''}
          onChange={handleChange('extracurricular')}
        />
      </Grid>
    </Grid>
  );
};